import EquipmentCalibrationActions from '../../equipment-calibration.actions';

/**
 * Creates a new EquipmentCalibrationVendorsController.
 * @class
 */
class EquipmentCalibrationVendorsController {
    constructor($ngRedux, $state, NavigationService, Notifier, EquipmentCalibrationActions) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.NavigationService = NavigationService;
        this.actions = EquipmentCalibrationActions;
        this.Notifier = Notifier;
    }

    $onInit() {
        const navConfig = this.NavigationService.getConfig(this.$state.$current);
        this.colorName = navConfig.colorName;
        this.icon = navConfig.icon;

        this.unsubscribe = this.$ngRedux.connect(this.mapState.bind(this), this.actions)(this);

        if (this.equipmentId) {
            this.identifier = 'app.equipmentCalibration.manage';
            this.state = 'app.equipmentCalibration.manage.vendors';
        }
        else {
            this.identifier = 'app.equipmentCalibration.add';
            this.state = 'app.equipmentCalibration.add.vendors';
        }

        this.getVendorServiceTypes(this.equipmentId)
            .then(() => {
                return this.getEquipmentVendors(this.equipmentId);
            })
            .then((items) => {
                items.forEach(item => {
                    this.getServiceTypeVendors(item.service_type_id);
                });
            });
    }

    mapState(state) {
        return {
            equipmentId: state.equipmentCalibration.equipment.id,
            serviceTypes: state.equipmentCalibration.serviceTypes
        }
    }

    manageEquipmentService(serviceType) {
        if (!serviceType.vendors?.length) {
            this.getServiceTypeVendors(serviceType.id);
        }
        if (!serviceType.selected && serviceType.selectedVendor?.uuid) {
            this.rejectEquipmentVendor(this.equipmentId, serviceType)
                .then(() => {
                    this.Notifier.success(serviceType.name + ' Vendor successfully removed');
                });
        }
    }

    onEquipmentServiceVendor(serviceType) {
        if (!serviceType.selectedVendor) {
            return;
        }
        this.assignEquipmentVendor(this.equipmentId, serviceType)
            .then(() => {
                this.Notifier.success(serviceType.name + ' Vendor successfully assigned');
            });
    }

    $onDestroy() {
        this.unsubscribe();
    }
}

EquipmentCalibrationVendorsController.$inject = ['$ngRedux', '$state', 'NavigationService', 'Notifier', 'EquipmentCalibrationActions'];

export const equipmentCalibrationVendors = {
    controller: EquipmentCalibrationVendorsController,
    template: require('./equipment-calibration-vendors.html')
};
